// src/components/ProductGrid.js - NOVO ESTILO PARA BOTÕES DE CATEGORIA

import React, { useState } from "react";
import ProductCard from "./productCard";
// ... (mantenha todas as suas importações de imagem) ...
import tenebrioMolitorImage from "../assets/image/Tenebrio/tenebrio1.png";
import tenebrioMolitorImage2 from "../assets/image/Tenebrio/tenebrio2.jpg";
import tenebrioMolitorImage3 from "../assets/image/Tenebrio/tenebrio3.jpg";
import tenebrioMolitorImage4 from "../assets/image/Tenebrio/tenebrio4.jpg";
import tenebrioMolitorImage5 from "../assets/image/Tenebrio/tenebrio5.jpg";
import tenebrioMolitorImage6 from "../assets/image/Tenebrio/tenebrio6.jpg";
import tenebrioMolitorImage7 from "../assets/image/Tenebrio/tenebrio7.jpg";
import tenebrioMolitorImage8 from "../assets/image/Tenebrio/tenebrio8.jpg";
import tenebrioMolitorImage9 from "../assets/image/Tenebrio/tenebrio9.jpg";
import tenebriogrande1 from "../assets/image/TenebrioMolitorGrande/tenebrio_grande1.jpg";
import tenebriogrande2 from "../assets/image/TenebrioMolitorGrande/tenebrio_grande2.jpg";
import tenebriogrande3 from "../assets/image/TenebrioMolitorGrande/tenebrio_grande3.webp";
import griloimage from "../assets/image/GrilosNegros/grilo.jpg";
import griloimage2 from "../assets/image/GrilosNegros/grilo2.jpg";
import griloimage3 from "../assets/image/GrilosNegros/grilos3.jpg";
import griloimage4 from "../assets/image/GrilosNegros/grilos4.jpg";
import griloimage5 from "../assets/image/GrilosNegros/grilo5.jpg";
import griloimage6 from "../assets/image/GrilosNegros/grilo6.jpg";
import dubiaimage1 from "../assets/image/Dubia/dubia1.jpg";
import dubiaimage2 from "../assets/image/Dubia/dubia2.jpg";
import dubiaimage3 from "../assets/image/Dubia/dubia3.jpg";
import dubiaimage4 from "../assets/image/Dubia/dubia4.jpg";
import dubiaimage5 from "../assets/image/Dubia/dubia5.jpg";
import dubiaimage6 from "../assets/image/Dubia/dubia6.jpg";
import dubiaimage7 from "../assets/image/Dubia/dubia7.jpg";
import combo1 from "../assets/image/Combos/combo1.jpg";
import combo2 from "../assets/image/Combos/combo2.jpg";
import combo3 from "../assets/image/Combos/combo3.jpg";
import combo4 from "../assets/image/Combos/combo4.jpg";



export default function ProductGrid({ addToCart }) {
  // Mantenha seu objeto productData aqui (certifique-se de que os paths das imagens estão corretos)
  const productData = {
    Dubia: [
      { 
        image: dubiaimage1,
        title: "Barata Dubia", 
        price: "40,00", 
        quantity: "50",
        description: "Alto teor de cálcio\nFácil digestão\nIdeal para reprodução e crescimento"
      },
      { 
        image: dubiaimage2, 
        title: "Barata Dubia", 
        price: "70,00", 
        quantity: "100", 
        description: "Rica em proteínas e minerais\nExcelente alimento vivo\nFavorece a energia e vitalidade"
      },
      { 
        image: dubiaimage3,
        title: "Barata Dubia", 
        price: "100,00", 
        quantity: "150", 
        description: "Alimento balanceado\nFácil manejo\nFortalece ossos e estrutura muscular"
      },
      { 
        image: dubiaimage4,
        title: "Barata Dubia", 
        price: "130,00", 
        quantity: "200",
        description: "Nutrição completa\nIdeal para criadores exigentes\nMaior taxa de reprodução"
      },
      { 
        image: dubiaimage5,
        title: "Barata Dubia", 
        price: "180,00", 
        quantity: "300", 
        description: "Fonte rica em cálcio e proteína\nAumenta o desempenho reprodutivo\nAlta palatabilidade"
      },
      { 
        image: dubiaimage6,
        title: "Barata Dubia", 
        price: "220,00", 
        quantity: "400", 
        description: "Inseto de alto valor nutricional\nFácil digestão\nPerfeito para dietas equilibradas"
      },
      { 
        image: dubiaimage7,  
        title: "Barata Dubia", 
        price: "250,00", 
        quantity: "500", 
        description: "Alta qualidade\nMelhora o crescimento e saúde dos animais\nFácil de armazenar e manter"
      },
    ],
    
    Tenebrios: {
      subcategories: {
        "Tenebrio Molitor": [
          { 
            image: tenebrioMolitorImage, 
            title: "Tenebrio Molitor", 
            price: "40,00", 
            quantity: "500",
            description: "45% de proteína\nRico em ferro e zinco\nEstimula o crescimento saudável"
          },
          { 
            image: tenebrioMolitorImage2, 
            title: "Tenebrio Molitor", 
            price: "45,00", 
            quantity: "600", 
            description: "Fonte natural de energia\nIdeal para aves e répteis\nFavorece o ganho de massa"
          },
          { 
            image: tenebrioMolitorImage3, 
            title: "Tenebrio Molitor", 
            price: "50,00", 
            quantity: "700", 
            description: "Excelente fonte de proteína animal\nMelhora o metabolismo e vigor\nAlta digestibilidade"
          },
          { 
            image: tenebrioMolitorImage4, 
            title: "Tenebrio Molitor", 
            price: "60,00", 
            quantity: "1000", 
            description: "Proteína de qualidade superior\nPerfeito para crescimento saudável\nRico em nutrientes essenciais"
          },
          { 
            image: tenebrioMolitorImage5, 
            title: "Tenebrio Molitor", 
            price: "90,00", 
            quantity: "1500", 
            description: "Ideal para manutenção e reprodução\nFornece energia constante\nAlta taxa de aceitação"
          },
          { 
            image: tenebrioMolitorImage9, 
            title: "Tenebrio Molitor", 
            price: "110,00", 
            quantity: "2000", 
            description: "Fonte natural de proteína\nAuxilia no fortalecimento muscular"
          },
          { 
            image: tenebrioMolitorImage6, 
            title: "Tenebrio Molitor", 
            price: "130,00", 
            quantity: "2500", 
            description: "Proteína animal pura\nIdeal para alimentação balanceada"
          },
          { 
            image: tenebrioMolitorImage7, 
            title: "Tenebrio Molitor", 
            price: "150,00", 
            quantity: "3000", 
            description: "Fonte de energia e proteína\nEstimula o apetite natural"
          },
          { 
            image: tenebrioMolitorImage8, 
            title: "Tenebrio Molitor", 
            price: "180,00", 
            quantity: "4000", 
            description: "Alto teor proteico\nExcelente para criação em larga escala"
          },
          { 
            image: tenebrioMolitorImage6, 
            title: "Tenebrio Molitor", 
            price: "200,00", 
            quantity: "5000", 
            description: "45% de proteína\nFonte de ferro e zinco\nFavorece o crescimento e vitalidade"
          },
        
        ],
        "Tenebrio Grande": [
          { 
            image: tenebriogrande1,
            title: "Tenebrio Grande", 
            price: "40,00", 
            quantity: "100", 
            description: "Rico em proteínas\nMaior tamanho e rendimento\nIdeal para aves de médio porte"
          },
          { 
            image: tenebriogrande2,
            title: "Tenebrio Grande", 
            price: "65,00", 
            quantity: "200", 
            description: "Mais massa por unidade\nExcelente digestão\nFonte de energia rápida"
          },
          { 
            image: tenebriogrande3,
            title: "Tenebrio Grande", 
            price: "90,00", 
            quantity: "300", 
            description: "Inseto robusto e nutritivo\nIdeal para pets e criatórios profissionais"
          },
        ],
      },
    },
    Grilo: [
      { 
        image: griloimage, 
        title: "Grilos Negros", 
        price: "40,00", 
        quantity: "50", 
        description: "Rico em proteína e B12\nAlta energia\nFavorece a vitalidade dos pets"
      },
      { 
        image: griloimage2,
        title: "Grilos Negros", 
        price: "70,00", 
        quantity: "100", 
        description: "Alimento completo e natural\nReforça imunidade\nFácil digestão"
      },
      { 
        image: griloimage3, 
        title: "Grilos Negros", 
        price: "100,00", 
        quantity: "150", 
        description: "Fonte ideal de proteína animal\nEstimula o apetite e crescimento"
      },
      { 
        image: griloimage4,
        title: "Grilos Negros", 
        price: "130,00", 
        quantity: "200", 
        description: "Proporciona energia e resistência\nMelhora a performance dos animais"
      },
      { 
        image: griloimage4,
        title: "Grilos Negros", 
        price: "180,00", 
        quantity: "300", 
        description: "Nutrição equilibrada\nPerfeito para dietas naturais e ricas em proteína"
      },
      { 
        image: griloimage5,
        title: "Grilos Negros", 
        price: "220,00", 
        quantity: "400", 
        description: "Alto valor biológico\nAjuda na reprodução e crescimento saudável"
      },
      { 
        image: griloimage6,
        title: "Grilos Negros", 
        price: "250,00", 
        quantity: "500", 
        description: "Proteína essencial\nIdeal para manutenção e energia prolongada"
      },
    ],
    
    Combos: [
      { 
        image: combo1, // Usando uma imagem temporária
        title: "Molitor + Tenebrio Gigante", 
        price: "40,00", 
        quantity: "300", 
        description: "250 Molitor \n50 Tenebrio Gigante" 
      },

      { 
        image: combo2, // Usando uma imagem temporária
        title: "Molitor + Tenebrio Gigante", 
        price: "70,00", 
        quantity: "600", 
        description: "500 Molitor \n100 Tenebrio Gigante" 
      },
      { 
        image: combo3, // Usando uma imagem temporária
        title: "Grilos + Baratas Dubia", 
        price: "40,00", 
        quantity: "50", 
        description: "25 Grilos \n 25 Baratas Dubia"  
      },
      { 
        image: combo3, // Usando uma imagem temporária
        title: "Grilos + Baratas Dubia ", 
        price: "70,00", 
        quantity: "100", 
        description: "50 Grilos \n 50 Baratas Dubia" 
      },
      { 
        image: combo4, // Usando uma imagem temporária
        title: "Grilo + Dubia + Tenebrio Gigante", 
        price: "85,00", 
        quantity: "125", 
        description: "50 Grilos\n 25 Baratas Dubia\n 50 Tenebrio Gigante" 
      },
      { 
        image: combo4, // Usando uma imagem temporária
        title: "Grilo + Dubia + Tenebrio Gigante", 
        price: "10,00", 
        quantity: "150", 
        description: "100 Grilos\n 50 Baratas Dubia\n Vice versa" 
      },
      { 
        image: combo4, // Usando uma imagem temporária
        title: "Grilo + Dubia + Tenebrio Gigante", 
        price: "160,00", 
        quantity: "300", 
        description: "100 Grilos\n 100 Baratas Dubia\n 100 Tenebrio Gigante" 
      },
    ],
  };

  // Estados para categorias e subcategorias selecionadas
  // Defina a categoria inicial como "Tenebrios" ou "Dubia" para que apareça ao carregar
  const [selectedCategory, setSelectedCategory] = useState("Tenebrios"); // Ou "Dubia" se preferir
  const [selectedSubcategory, setSelectedSubcategory] = useState(
    selectedCategory === "Tenebrios"
      ? Object.keys(productData.Tenebrios.subcategories)[0]
      : null
  );

  const renderProducts = () => {
    const categoryData = productData[selectedCategory];

    if (!categoryData) {
        return <p className="text-center text-gray-500 col-span-full">Nenhum produto encontrado nesta categoria.</p>;
    }

    if (selectedCategory === "Tenebrios" && selectedSubcategory) {
      const products = categoryData.subcategories[selectedSubcategory];
      return products.map((product, index) => (
        <ProductCard
          key={product.title + index} // Usar title + index para chave única
          image={product.image}
          title={product.title}
          price={product.price}
          quantity={product.quantity}
          description={product.description}
          addToCart={addToCart}
        />
      ));
    }

    if (Array.isArray(categoryData)) {
      return categoryData.map((product, index) => (
        <ProductCard
          key={product.title + index} // Usar title + index para chave única
          image={product.image}
          title={product.title}
          price={product.price}
          quantity={product.quantity}
          description={product.description}
          addToCart={addToCart}
        />
      ));
    }
    return null;
  };

  return (
    <div className="px-4 py-12 max-w-7xl mx-auto" id="produtos">
      {/* Título da Seção */}
      <div className="text-center mb-10">
        <h2 className="text-4xl font-extrabold text-green-800 tracking-tight">NOSSOS PRODUTOS</h2>
        <p className="mt-2 text-xl text-gray-600">Nutrição Superior para Seus Animais</p>
      </div>

      {/* Filtros de Categoria */}
      <div className="mb-10 flex justify-center gap-3 md:gap-4 flex-wrap">
        {Object.keys(productData).map((category) => (
          <button
            key={category}
            onClick={() => {
              setSelectedCategory(category);
              setSelectedSubcategory(
                category === "Tenebrios"
                  ? Object.keys(productData.Tenebrios.subcategories)[0]
                  : null
              );
            }}
            className={`px-6 py-3 rounded-full text-base font-bold transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg
              ${selectedCategory === category
                ? "bg-orange-500 text-white shadow-md"
                : "bg-green-600 text-white hover:bg-green-700" // Cor principal verde para os botões não selecionados
              }`}
          >
            {category === "Dubia" ? "BARATAS DUBIA" : category.toUpperCase()} {/* Renomeia 'Dubia' para 'TODOS' */}
          </button>
        ))}
      </div>

      {/* Filtros de Subcategorias (se houver) */}
      {selectedCategory === "Tenebrios" && (
        <div className="mb-10 flex justify-center gap-3 md:gap-4 flex-wrap">
          <h3 className="sr-only">Subcategorias de Tenebrios</h3> {/* Esconde visualmente */}
          {Object.keys(productData.Tenebrios.subcategories).map((subcategory) => (
            <button
              key={subcategory}
              onClick={() => setSelectedSubcategory(subcategory)}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-all duration-300
                ${selectedSubcategory === subcategory
                  ? "bg-green-700 text-white shadow-md"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
            >
              {subcategory}
            </button>
          ))}
        </div>
      )}

      {/* Exibição dos produtos */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
        {renderProducts()}
      </div>
       
    </div>
  );
}

